import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        userInfo: JSON.parse(window.localStorage.getItem('user')) || {}
    },
    mutations: {
        setUser(state, payload) {
            state.userInfo = payload
            window.localStorage.setItem('user', JSON.stringify(payload))
        }
    }
})
// 暴露出去
export default store;